<mat-toolbar class="header">
  <mat-toolbar-row class="header" fxLayout="row">
    <a mat-button routerLink="">
      <!--<img class="logo" src="assets/img/cc-logo.png" />-->
    </a>

    <div fxFlex></div>

    <button mat-button [matMenuTriggerFor]="menu">{{currentLanguage}}</button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="languageSelected('EN')">EN</button>
      <button mat-menu-item (click)="languageSelected('DE')">DE</button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
